module.exports = __webpack_public_path__ + "img/parco-auto.48dede41.svg";